/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { FlexContainer, Text, Body, Stack, colors } from "@carrotfertility/carotene"
import styled from "styled-components"
import Tooltip from "components/Tooltip"
import { MultiPathSVG } from "components/views/SVG"
import { insuranceQuestions } from "./insuranceQuestions"
import { getPiiProps } from "services/tracking"

const cellStyling = `
  padding-right: 24px;
  text-align: left;
  padding-top: 40px;
`
const RowHeader = styled.th`
  ${cellStyling}
  width: 420px;
`
const RowCell = styled.td`
  ${cellStyling}
`

const HelpIconContainer = styled.span`
  margin-left: 5px;
  display: inline-block;
  vertical-align: text-top;
  color="#e48400" 
`

const ItalizedText = styled(Text)`
  font-style: italic;
`

const TooltipParagraphs = ({ tooltipText }: { tooltipText: string[] }): JSX.Element => (
  <Stack sx={{ padding: "32px 24px" }} spacing="small">
    {tooltipText.map((text, index) => (
      <Body key={index}>{text}</Body>
    ))}
  </Stack>
)

export type InsurancePlanInformationRowData = {
  headerLabel: string
  memberData?: string
  partnerData?: string
  tooltipText?: string[]
  helperText?: string
}

export interface InsurancePlanInformationRowProps extends InsurancePlanInformationRowData {
  hasPartner: boolean
  insuranceExpired: boolean
}

const PlanInformationRow = (props: InsurancePlanInformationRowProps): JSX.Element => {
  const { headerLabel, memberData, partnerData, tooltipText, helperText, hasPartner, insuranceExpired } = props

  let textColor = `${colors.base.black}`

  if (insuranceExpired && headerLabel === insuranceQuestions.WHEN_IS_YOUR_DEDUCTIBLE_PERIOD["defaultMessage"]) {
    textColor = `${colors.base.errorRed}`
  }

  return (
    <tr>
      <RowHeader>
        <FlexContainer>
          <Text weight="bold" size="medium">
            {headerLabel}
            {tooltipText && (
              <Tooltip content={(): JSX.Element => <TooltipParagraphs tooltipText={tooltipText} />}>
                <HelpIconContainer>
                  <MultiPathSVG iconName="icn-help-orange" />
                </HelpIconContainer>
              </Tooltip>
            )}
          </Text>
        </FlexContainer>
        <ItalizedText variant="subtext" size="medium">
          {helperText}
        </ItalizedText>
      </RowHeader>
      <RowCell>
        <Text {...getPiiProps()} size="medium" style={{ color: textColor }}>
          {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
          {memberData ? memberData : "--"}
        </Text>
      </RowCell>
      {hasPartner && (
        <RowCell {...getPiiProps()}>
          <Text size="medium" style={{ color: textColor }}>
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            {partnerData ? partnerData : "--"}
          </Text>
        </RowCell>
      )}
    </tr>
  )
}

export default PlanInformationRow
